import instance from "../../../../../services/api";

export const getRemontsAccounting = async (params = {}) => {
  return await instance(true)
    .get(`/partner/accounting/`, { params })
    .then(res => res?.data);
};
